module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-a life",
    style: ({
      backgroundImage: 'url(' + _vm.content.life.bg + ')'
    })
  }, [_c('div', {
    staticClass: "section__container section-a__container life__content"
  }, [_c('div', {
    staticClass: "section__header section-a__header life__header"
  }, [_c('div', {
    staticClass: "section__header-subtitle section-a__header-subtitle life__header-subtitle"
  }, [_vm._v(_vm._s(_vm.content.life.subtitle) + "      ")]), _c('div', {
    staticClass: "section__header-title section-a__header-title life__header-title"
  }, [_vm._v(_vm._s(_vm.content.life.title))])]), _c('div', {
    staticClass: "section-a__text life__text"
  }, [_vm._v(_vm._s(_vm.content.life.text)), _c('Accordion', {
    attrs: {
      "content": _vm.content.life
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2651e88f"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-braces-life/custom-braces-life.pug
// module id = 504
// module chunks = 1